











































import {Component, Vue} from 'vue-property-decorator'

import {Logo} from '@/icons'

@Component({
  components: {
    Logo
  }
})
export default class MainMenu extends Vue {
  handleOpenUrl(url: string) {
    window.open(url, '_blank')
  }
}
